import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import { Autocomplete, Grid, MenuItem, TextField, Typography, } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { productStatusList } from "src/config";
import { MenuProps } from "src/components/hook-form/RHFSelectMulti";
import { ordersUpdate, allCourierCompany, getAllRiders, } from "src/pages/api";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MultipleOrderUpdate({
  data,
  onClose,
  selectedSchool,
  isbulk,
  // refetch, 
}) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const [status, setSelectedStatus] = React.useState("");
  const [lotNumber, setLotNumber] = React.useState("");
  const [deliveryComp, setDeliveryComp] = React.useState("");
  const [rider, setRider] = React.useState(null);

  const mutation = useMutation((req) => ordersUpdate({ req }), {
    onSuccess: () => {
      enqueueSnackbar(`Status Updated`, {
        variant: "success",
      });
      
      queryClient.invalidateQueries(["courier-orderList"]); 
      // refetch();
      onClose();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || "Failed to Update", {
        variant: "error",
      });
    },
  });
  

  const { data: deliveryCompany } = useQuery({
    queryKey: ["allCourierCompany"],
    queryFn: allCourierCompany,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  const { data: companyRiders } = useQuery({
    queryKey: ["getAllRiders"],
    queryFn: getAllRiders,
    staleTime: Infinity,
    cacheTime: Infinity,
    // enabled: !!deliveryComp,
  });
  const handleUpdate = () => {
    if (status) {
      if (status === 4 && lotNumber === "") {
        enqueueSnackbar("Please Enter Lot Number", { variant: "error" });
        return;
      }
      if (status === 4 && deliveryComp === "") {
        enqueueSnackbar("Please select delivery Company", {
          variant: "error",
        });
        return;
      }

      const req = {
        schoolID: selectedSchool,
        packageID: data.length > 0 ? data[0]?.original?.packageID : undefined,
        orderIDs: data.map((el) => el?.original?.orderID).join(","), 
        status: status,
        lotNumber: status === 4 ? lotNumber : undefined,
        delivery_company_id: status === 4 ? deliveryComp : undefined,
        riderID: status === 4 && rider ? rider.RiderId : undefined,  
      };
        mutation.mutate(req);
    }

    // return;
  };
  return (
    <Dialog
      open
      TransitionComponent={Transition}
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent dividers>
        <DialogContentText id="alert-dialog-slide-description">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography color={"black"} variant="body2">
                <b>Selected Order Id:</b>
                <br />
                {data.map((el) => el?.original?.orderID).join(" , ")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Select Status"
                select
                size="small"
                SelectProps={{ native: false, MenuProps: MenuProps }}
                fullWidth
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                }}
                value={status}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {productStatusList.slice(3, 11).map((el) => (
                  <MenuItem value={el.value} key={el.value}>
                    {el.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            {status === 4 && (
              <>
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    label="Lot Number"
                    fullWidth
                    onChange={(e) => {
                      setLotNumber(e.target.value);
                    }}
                    value={lotNumber}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    label={"Delivery Company"}
                    select
                    fullWidth
                    value={deliveryComp}
                    SelectProps={{ native: false }}
                    onChange={(e) => {
                      setDeliveryComp(e.target.value);
                    }}
                  >
                    <MenuItem value="">Select Courier Company</MenuItem>
                    {deliveryCompany?.data.map((el) => (
                      <MenuItem value={el.company_ID} key={el.company_ID}>
                        {el.company_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    size="small"
                    options={companyRiders?.data || []}
                    getOptionLabel={(option) => option.RiderName}
                    fullWidth
                    value={rider || null}
                    onChange={(e, v) => {
                      setRider(v);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"Select Rider"}
                        placeholder="Select Rider"
                      />
                    )}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          onClick={handleUpdate}
          color="primary"
          variant="contained"
          loading={mutation.isLoading}
          disabled={!status}
        >
          Update
        </LoadingButton>
        <Button onClick={onClose} color="error" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
